import React, { useEffect, useRef, useState } from 'react';

import validate from '../validators/validateText';

const QuestionFormText = ({ focus, question, savedAnswer, onChange, children }) => {
  const [text, setText] = useState(savedAnswer || question.prefill || '');
  const inputRef = useRef(null);

  const handleChange = event => {
    setText(event.target.value);
    onChange(question.key, event.target.value, validate);
  };

  let customInputType;
  if (question.validator === 'EMAIL') customInputType = 'email';
  else if (question.validator === 'PHONE') customInputType = 'tel';

  return (
    <div>
      <div className="field">
        <div className="control">
          <input
            autoFocus={focus}
            ref={inputRef}
            type={customInputType || 'text'}
            value={text}
            className="input is-medium"
            onChange={handleChange}
            maxLength={(question.maxLength) ? question.maxLength : 524288}
          />
        </div>
      </div>
      {children}
    </div>
  );
};

export default QuestionFormText;
